// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.8.0",
  date: "2026-08-28T11:30:03.282Z",
  gitInfo: {
    dirty: false,
    raw: "d19e63d27",
    hash: "d19e63d27",
    distance: null,
    tag: null,
    semver: null,
    suffix: "d19e63d27",
    semverString: null
  }
};
/* tslint:enable */
